import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';


class Nav extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this) 
}

handleLogout() {
  this.props.logout();
}

render() {
  return (
  
<div>
  <div className="description">
    <p className="promotion">Challenge to build 30 websites in 30 days!</p>
  </div>
    <div className="menu">
       <ul>
        <li><Link to="/">Home</Link></li>
       <li><Link to="/about">About</Link></li>
       <li><Link to="/sites">Projects</Link></li>
       <li><a href="http://www.berniris.com" target="_new">Berniris.com</a></li>
       <li><Link to="/contact">Contact</Link></li>
    </ul>
 </div>
 </div>



    );
  }
}

export default Nav;